import React, { useState, useRef, useEffect } from 'react'
import { getTrafficPostEoiPath } from '../trafficCourseFlowUtils'
import Page1 from '../assets/Page1-Traffic.png'
import Input from '../components/Input'
import Dropdown from '../components/Dropdown'
import { getUrlParams, randomString, reverseDateString } from '../common'
import MyDropzone from '../components/MyDropzone'
import Checkbox from '../components/Checkbox'
import SignatureCanvas from 'react-signature-canvas'
import axios from 'axios'
import { format, isAfter, isBefore } from 'date-fns'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { clearPageMessage, showLoadingMessage, showWarningMessage } from '../successMessage'
import MyCalendar from '../components/Calendar'
import Radio from '../components/Radio'
import { trainers } from '../constants'
import AddressSearch from '../components/AddressSearch'
import StudentDetailConfirmationModal from '../components/StudentDetailConfirmationModal'
import { pilotAttach, pilotRequest, pilotSubmission, pilotEnrolmentId, pilotFunctionUrl } from '../bookingPilotClient'
import {
    buildStudentDetailFieldValues,
    buildStudentDetailVerificationAudit,
    buildStudentDetailVerificationSnapshot,
    createStudentDetailVerificationState,
} from '../studentDetailVerification'

const Traffic = () => {

    const [page, setPage] = useState(0)
    const [priorChecked, setPriorChecked] = useState(Boolean(pilotEnrolmentId()) || window.location.pathname.includes('trafficControl'))
    const [priorNotice, setPriorNotice] = useState('')
    const [startRequestId] = useState(() => window.crypto.randomUUID())
    const [errors, setErrors] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const [showDetailConfirmationModal, setShowDetailConfirmationModal] = useState(false)
    const [detailConfirmationState, setDetailConfirmationState] = useState(createStudentDetailVerificationState())
    const [detailConfirmationSnapshot, setDetailConfirmationSnapshot] = useState('')

    // Page = 0
    const [studentName, setStudentName] = useState('')
    const [trainingCourse, setTrainingCourse] = useState(window.location.pathname.includes('trafficControl') ? 'Traffic Control' : 'Traffic Management Implementer Course')
    const [dateFirstPage, setDateFirstPage] = useState(new Date())
    const [trainerName, setTrainerName] = useState('') //Optional.

    const [iCan, setICan] = useState(['', '', '', '', '', '', '', '', '', '', ''])
    const iCanLabels = [
        'Write a SMS message',
        'Check change when shopping',
        'Read a TV guide',
        'Read an email',
        'Read a map',
        'Write a job application',
        'Calculate fractions, decimals and percentages',
        'Write a work report',
        'Read the prompts on an ATM',
        'Use a calculator',
        'Read an account or bill',
    ]

    const [alphabetWordOne, setAlphabetWordOne] = useState('')
    const [alphabetWordTwo, setAlphabetWordTwo] = useState('')
    const [alphabetWordThree, setAlphabetWordThree] = useState('')
    const [alphabetWordFour, setAlphabetWordFour] = useState('')
    const [alphabetWordFive, setAlphabetWordFive] = useState('')
    const [alphabetWordSix, setAlphabetWordSix] = useState('')

    const incorrectWords = ['Mondey', 'Bus', 'Pensil', 'Shoes', 'Food', 'Phone', 'Cleen', 'House', 'Play', 'Tecnical']
    const [chosenIncorrectWords, setChosenIncorrectWords] = useState([])
    const [whyInterested, setWhyInterested] = useState('')

    const [mathWordOne, setMathWordOne] = useState('')
    const [mathWordTwo, setMathWordTwo] = useState('')
    const [mathWordThree, setMathWordThree] = useState('')
    const [mathWordFour, setMathWordFour] = useState('')
    const [mathWordFive, setMathWordFive] = useState('')


    const [whyFollow, setWhyFollow] = useState('')
    const [familiarWith, setFamiliarWith] = useState('')
    const [vehicleExamples, setVehicleExamples] = useState('')
    const [oralDiscussion, setOralDiscussion] = useState('')


    const [chosenPrimaryDocument, setChosenPrimaryDocument] = useState('')


    const [title, setTitle] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [otherName, setOtherName] = useState('')


    const [address, setAddress] = useState('')
    const [addressManualFill, setAddressManualFill] = useState(false)
    const [lockAddressManualFields, setLockAddressManualFields] = useState(false)

    const [streetNumber, setStreetNumber] = useState('')
    const [streetName, setStreetName] = useState('')
    const [suburb, setSuburb] = useState('')
    const [state, setState] = useState('')
    const [postcode, setPostcode] = useState('')

    const [postalAddressSame, setPostalAddressSame] = useState(false)

    const [addressPostal, setAddressPostal] = useState('')
    const [addressPostalManualFill, setAddressPostalManualFill] = useState(false)
    const [lockAddressPostalManualFields, setLockAddressPostalManualFields] = useState(false)


    const [streetNumberPostal, setStreetNumberPostal] = useState('')
    const [streetNamePostal, setStreetNamePostal] = useState('')
    const [suburbPostal, setSuburbPostal] = useState('')
    const [statePostal, setStatePostal] = useState('')
    const [postcodePostal, setPostcodePostal] = useState('')


    const [dob, setDob] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [email, setEmail] = useState('')

    // School 
    const [passportNumber, setPassportNumber] = useState('')
    const [birthCertificate, setBirthCertificate] = useState('')
    const [birthStateIssue, setBirthStateIssue] = useState('')
    const [citizenCert, setCitizenCert] = useState('')
    const [ausLicense, setAusLicense] = useState('')
    const [ausLicenseStateIssue, setAusLicenseStateIssue] = useState('')

    // Overseas
    const [passportCountry, setPassportCountry] = useState('')

    // General
    const [boatLicense, setBoatLicense] = useState('')
    const [boatLicenseStateIssue, setBoatLicenseStateIssue] = useState('')

    const [nswPhotoLicense, setNswPhotoLicense] = useState('')
    const [highRiskLicense, setHighRiskLicense] = useState('')
    const [highRiskLicenseState, setHighRiskLicenseState] = useState('')

    const [proofAgeLicense, setProofAgeLicense] = useState('')
    const [proofAgeLicenseState, setProofAgeLicenseState] = useState('')
    const [policeCard, setPoliceCard] = useState('')

    const [pointsDocuments, setPointsDocuments] = useState([])
    // const [declareHundredPoints, setDeclareHundredPoints] = useState(false)


    const [declarationDate, setDeclarationDate] = useState(format(new Date(), 'dd-MM-yyyy'))
    const [trainerId, setTrainerId] = useState('')
    const [delivery, setDelivery] = useState('')

    const signatureRef = useRef()
    const [pilotError, setPilotError] = useState('')
    const [pilotLoading, setPilotLoading] = useState(Boolean(pilotEnrolmentId()))
    useEffect(() => {
        if (!pilotEnrolmentId()) return;
        pilotRequest('formContext').then(context => {
            if (!['tc', 'imp', 'combo'].includes(context.course)) throw new Error('This form is not for your booked course.');
            setFirstName(context.person.firstName); setLastName(context.person.lastName);
            setStudentName(`${context.person.firstName} ${context.person.lastName}`);
            setEmail(context.person.email); setPhoneNumber(context.person.phoneNumber);
            setDob(context.person.dob.split('-').reverse().join('/'));
            setTrainerId(context.trainerId); setDelivery(context.delivery); setDateFirstPage(new Date(`${context.date}T12:00:00`));
        }).catch(error => setPilotError(error.message)).finally(() => setPilotLoading(false));
    }, [])

    const navigate = useNavigate()


    useEffect(() => {
        const params = getUrlParams()
        if (params.trainerId || params.trainerid) {
            setTrainerId(params.trainerId || params.trainerid)
        } else {
            toast.error('Trainer ID is required!!!', { position: 'top-center' })
            return
        }

        if (params.delivery) {
            setDelivery(params.delivery[0].toUpperCase() + params.delivery.substring(1))
        } else {
            toast.error('Delivery method is required!!!', { position: 'top-center' })
        }
    }, [])

    useEffect(() => {
        if (trainerId) {
            const matchingTrainer = trainers.find(r => r.trainerId === trainerId)
            if (matchingTrainer) {
                setTrainerName(matchingTrainer.name)
            }
        }
    }, [trainerId])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [page])

    useEffect(() => {
        if (postalAddressSame) {
            setStreetNumberPostal(streetNumber)
            setStreetNamePostal(streetName)
            setSuburbPostal(suburb)
            setPostcodePostal(postcode)
            setStatePostal(state)
            setAddressPostal(address)
            setLockAddressPostalManualFields(true)
        }
    }, [postalAddressSame])

    const pointsDocumentOptions = ['Credit/Debit card/Statement (1)', 'Credit/Debit card/Statement (2)', 'Current Medicare card', 'Telephone Bill (issued in last 3 months)', 'Utility Bill (issued in last 3 months)', 'Current Centrelink card', 'Current Vehicle Registration', 'Property Lease Agreement', 'Motor Vehicle Insurance', 'Council Rates notice (issued in last 3 months)', 'Home Insurance papers', 'Dept Veterans Affairs card']


    const newFirstPageValidations = [
        // { name: 'usi', value: usi },
        { name: 'studentName', value: studentName },
        { name: 'trainingCourse', value: trainingCourse },
        { name: 'iCan', value: iCan, array: true },

        // { name: 'alphabetWords', value: alphabetWords, array: true },
        { name: 'alphabetWordOne', value: alphabetWordOne },
        { name: 'alphabetWordTwo', value: alphabetWordTwo },
        { name: 'alphabetWordThree', value: alphabetWordThree },
        { name: 'alphabetWordFour', value: alphabetWordFour },
        { name: 'alphabetWordFive', value: alphabetWordFive },
        { name: 'alphabetWordSix', value: alphabetWordSix },
        { name: 'chosenIncorrectWords', value: chosenIncorrectWords, array: true },
        { name: 'whyInterested', value: whyInterested },
        { name: 'mathWordOne', value: mathWordOne },
        { name: 'mathWordTwo', value: mathWordTwo },

        { name: 'mathWordThree', value: mathWordThree },
        { name: 'mathWordFour', value: mathWordFour },
        { name: 'mathWordFive', value: mathWordFive },
        { name: 'whyFollow', value: whyFollow },
        { name: 'familiarWith', value: familiarWith },
        { name: 'vehicleExamples', value: vehicleExamples },
        // { name: 'oralDiscussion', value: oralDiscussion },
    ]

    const firstPageValidations = [
        // { name: 'usi', value: usi },
        { name: 'title', value: title },
        { name: 'firstName', value: firstName },
        { name: 'lastName', value: lastName },

        { name: 'streetNumber', value: streetNumber },
        { name: 'streetName', value: streetName },
        { name: 'suburb', value: suburb },
        { name: 'state', value: state },
        { name: 'postcode', value: postcode },

        { name: 'streetNumberPostal', value: streetNumberPostal },
        { name: 'streetNamePostal', value: streetNamePostal },
        { name: 'suburbPostal', value: suburbPostal },
        { name: 'statePostal', value: statePostal },
        { name: 'postcodePostal', value: postcodePostal },
        { name: 'dob', value: dob },
        { name: 'phoneNumber', value: phoneNumber },
        { name: 'email', value: email },
        // { name: 'emailConf', value: emailConf },
    ]

    console.log('pointsDocuments', pointsDocuments)

    const submitForm = async (studentDetailVerification) => {
        let additionalPayload = {}
        const primaryDocument = chosenPrimaryDocument?.value

        if (primaryDocument === 'Birth Certificate') {
            additionalPayload = {
                birthCertificate,
                birthStateIssue: birthStateIssue?.value,
            }
        } else if (primaryDocument === 'Australian / International Passport') {
            additionalPayload = {
                passportNumber,
                passportCountry,
            }

        } else if (primaryDocument === 'Australian Citizenship Certificate') {
            additionalPayload = { citizenCert }
        }

        additionalPayload = {
            chosenPrimaryDocument: primaryDocument || '',
            ...additionalPayload,
            ausLicense,
            ausLicenseStateIssue: ausLicenseStateIssue && ausLicenseStateIssue.value,
            boatLicense,
            boatLicenseStateIssue: boatLicenseStateIssue && boatLicenseStateIssue.value,
            nswPhotoLicense,
            highRiskLicense,
            highRiskLicenseState: highRiskLicenseState?.value || '',
            proofAgeLicense,
            proofAgeLicenseState: proofAgeLicenseState?.value || '',
            policeCard,
            pointsDocuments: pointsDocuments.map(row => row.value),
        }

        try {
            setLoading(true)
            showLoadingMessage('Submitting Traffic EOI')
            const resp = await axios.post(pilotFunctionUrl('trafficEOI'), {
                pilot: pilotSubmission(),
                data: {
                    studentName,
                    trainingCourse,
                    trainingType: window.location.pathname.includes('trafficControl') ? 'trafficControl' : 'trafficImplementation',
                    dateFirstPage,
                    iCan,
                    alphabetWords: [alphabetWordOne, alphabetWordTwo, alphabetWordThree, alphabetWordFour, alphabetWordFive, alphabetWordSix],
                    chosenIncorrectWords,
                    whyInterested,
                    mathWordOne,
                    mathWordTwo,
                    mathWordThree,
                    mathWordFour,
                    mathWordFive,
                    whyFollow,
                    familiarWith,
                    vehicleExamples,
                    oralDiscussion,
                    trainerId,
                    delivery,
                    ...additionalPayload,
                    title: title.value,
                    firstName,
                    lastName,
                    otherName,
                    email,
                    phoneNumber,
                    dob,
                    address,
                    streetNumber,
                    streetName,
                    postcode,
                    suburb,
                    state: state.value,
                    postalAddressSame,
                    addressPostal,
                    streetNumberPostal,
                    streetNamePostal,
                    postcodePostal,
                    suburbPostal,
                    statePostal: statePostal.value,
                    studentDetailVerification,
                    declarationDate,
                    signature: signatureRef.current.getTrimmedCanvas().toDataURL('image/png')
                }
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                }
            })

            setLoading(false)
            setShowDetailConfirmationModal(false)
            window.scrollTo({ top: 0, behavior: 'smooth' })
            clearPageMessage()
            const trainingType = window.location.pathname.includes('trafficControl') ? 'trafficControl' : 'trafficImplementation'
            if (pilotEnrolmentId()) {
                const linked = await pilotAttach('attachEoi', { documentId: resp.data.documentId });
                if (!linked.linked) showWarningMessage(`Your EOI was submitted. ${linked.error} Your trainer can finish linking it - do not submit this form again.`);
                navigate('/student-pilot');
            } else navigate(getTrafficPostEoiPath(resp.data, trainingType))
        } catch (e) {
            clearPageMessage()
            showWarningMessage(e.response?.data?.error || `${window.location.pathname.includes('trafficControl') ? 'Traffic Controller' : 'Traffic Implement'} EOI could not be submitted. Please try again.`)
            setLoading(false)
            console.error('e', e)
        }
    }

    const handleDetailConfirmationSubmit = async () => {
        const fieldValues = buildStudentDetailFieldValues({
            firstName,
            lastName,
            email,
            dob,
            streetNumber,
            streetName,
            suburb,
            state,
            postcode,
            streetNumberPostal,
            streetNamePostal,
            suburbPostal,
            statePostal,
            postcodePostal,
        })

        const studentDetailVerification = buildStudentDetailVerificationAudit({
            confirmationState: detailConfirmationState,
            fieldValues,
        })

        await submitForm(studentDetailVerification)
    }

    const handleNext = async () => {

        let tempErrors = []
        if (page === 0) {
            newFirstPageValidations.forEach(row => {
                if (row.array) {
                    console.log(row.name, row.value)
                    if (row.value.length === 0 || row.value.filter(r => !r).length > 0) {
                        tempErrors.push(row.name)
                    }
                } else {
                    if (!row.value) {
                        tempErrors.push(row.name)
                    }
                }
            })
            if (tempErrors.length > 0) {
                setErrors(tempErrors)
                setErrorMessage('Please fill all the fields.')
                return
            } else {
                //Additional checks
            }

        } else if (page === 2) {
            // if (!chosenPrimaryDocument) {
            //     setErrors(['chosenPrimaryDocument'])
            //     setErrorMessage('Choose one option.')
            //     return
            // }

            if (chosenPrimaryDocument && chosenPrimaryDocument.value === 'Birth Certificate') {
                if (!birthCertificate) {
                    setErrors(['birthCertificate'])
                    setErrorMessage('Birth Certificate Number is required.')
                    return
                } else if (!birthStateIssue || !birthStateIssue.value) {
                    setErrors(['birthStateIssue'])
                    setErrorMessage('Birth State required.')
                    return
                }
            } else if (chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian / International Passport') {
                if (!passportNumber) {
                    setErrors(['passportNumber'])
                    setErrorMessage('Passport Number is required.')
                    return
                } else if (!passportCountry || !passportCountry) {
                    setErrors(['birthStateIssue'])
                    setErrorMessage('Birth State required.')
                    return
                }

            } else if (chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian Citizenship Certificate') {
                if (!citizenCert) {
                    setErrors(['citizenCert'])
                    setErrorMessage('Citizenship Certificate Number is required.')
                    return
                }
            }

            // Check secondary document details.

            if (!ausLicense && !boatLicense && !nswPhotoLicense && !highRiskLicense && !proofAgeLicense && !policeCard && pointsDocuments.length === 0) {
                setErrors(['secondaryDoc'])
                setErrorMessage('Provide atleast one secondary document details.')
                return
            }

            if (ausLicense && (!ausLicenseStateIssue || !ausLicenseStateIssue.value)) {
                setErrors(['secondaryDoc'])
                setErrorMessage('Provide state of issue for secondary documents.')
                return
            } else if (boatLicense && (!boatLicenseStateIssue || !boatLicenseStateIssue.value)) {
                setErrors(['secondaryDoc'])
                setErrorMessage('Provide state of issue for secondary documents.')
                return
            } else if (highRiskLicense && (!highRiskLicenseState || !highRiskLicenseState.value)) {
                setErrors(['secondaryDoc'])
                setErrorMessage('Provide state of issue for secondary documents.')
                return
            } else if (proofAgeLicense && (!proofAgeLicenseState || !proofAgeLicenseState.value)) {
                setErrors(['secondaryDoc'])
                setErrorMessage('Provide state of issue for secondary documents.')
                return
            }

            if (pointsDocuments.length < 2 && !ausLicense && !boatLicense && !nswPhotoLicense && !highRiskLicense && !proofAgeLicense && !policeCard) {
                setErrors(['pointsDocuments'])
                setErrorMessage('Provide minimum of 2 points documents to meet criteria.')
                return
            }



        } else if (page === 3) {
            firstPageValidations.forEach(row => {
                if (!row.value) {
                    tempErrors.push(row.name)
                }
            })
            if (tempErrors.length > 0) {
                setErrors(tempErrors)
                setErrorMessage('Please fill all the fields.')
                return
            } else {
                if (!postcode.match(/^\d+$/) || postcode.length !== 4) {
                    setErrors(['postcode'])
                    setErrorMessage('Please enter a valid Postcode.')
                    return
                } else if (!postcodePostal.match(/^\d+$/) || postcodePostal.length !== 4) {
                    setErrors(['postcodePostal'])
                    setErrorMessage('Please enter a valid Postcode.')
                    return
                }
                else if (phoneNumber.match(/^[A-Za-z]+$/)) {
                    setErrors(['phoneNumber'])
                    setErrorMessage('Please enter a valid Phone Number. Cannot include alphabets.')
                    return
                }
                // else if (phoneNumber.length < 10) {
                //     setErrors(['phoneNumber'])
                //     setErrorMessage('Please enter a valid Phone Number.')
                //     return
                // } 
                else if (!dob.match(/^(0[1-9]|[12][0-9]|3[01])[\/](0[1-9]|1[012])[\/](19|20)\d\d$/)) {
                    setErrors(['dob'])
                    setErrorMessage('Please enter a valid DOB & match expected format.')
                    return
                } else if (isAfter(new Date(dob.split('-')[2] + '/' + dob.split('-')[1] + '/' + dob.split('-')[0]), new Date())) {
                    setErrors(['dob'])
                    setErrorMessage('Please enter a valid DOB. DOB should be in the past.')
                    return
                } else if (!email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                    setErrors(['email'])
                    setErrorMessage('Please enter a valid email.')
                    return
                } else if (!declarationDate) {
                    setErrors(['declarationDate'])
                    setErrorMessage('Please enter a valid Declaration Date.')

                    return

                } else if (signatureRef.current.isEmpty()) {
                    setErrors(['signature'])
                    setErrorMessage('Please provide a signature.')
                    return
                }
                // else if (!emailConf.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                //     setErrors(['emailConf'])
                //     setErrorMessage('Please enter a valid email Confirmation.')
                //     return
                // } else if (emailConf.trim() !== email.trim()) {
                //     setErrors(['emailConf'])
                //     setErrorMessage('Emails don\'t match.')
                //     return
                // }
            }
        }

        setErrorMessage('')
        setErrors([])
        page !== 3 && setPage(page + 1)

        if (page === 3) {
            const fieldValues = buildStudentDetailFieldValues({
                firstName,
                lastName,
                email,
                dob,
                streetNumber,
                streetName,
                suburb,
                state,
                postcode,
                streetNumberPostal,
                streetNamePostal,
                suburbPostal,
                statePostal,
                postcodePostal,
            })
            const nextSnapshot = buildStudentDetailVerificationSnapshot(fieldValues)

            if (detailConfirmationSnapshot !== nextSnapshot) {
                setDetailConfirmationState(createStudentDetailVerificationState())
                setDetailConfirmationSnapshot(nextSnapshot)
            }

            setShowDetailConfirmationModal(true)

        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    const goToPrevPage = () => {
        if (page > 0) {
            setPage(page - 1)
            setErrorMessage('')
            setErrors([])
        }
    }

    const toggleIncorrectWords = (word, value) => {
        if (value && !chosenIncorrectWords.includes(word)) {
            setChosenIncorrectWords([...chosenIncorrectWords, word])
        } else {
            setChosenIncorrectWords(chosenIncorrectWords.filter(r => r !== word))
        }

    }

    const handleDobChange = value => {
        const digits = value.replace(/\D/g, '').slice(0, 8)
        const formatted = digits.length > 4
            ? `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
            : digits.length > 2
                ? `${digits.slice(0, 2)}/${digits.slice(2)}`
                : digits
        setDob(formatted)
    }

    const checkPreviousTrafficCourse = async () => {
        setLoading(true)
        setPriorNotice('')
        try {
            const { data } = await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/startTrafficImplement', {
                person: { firstName, lastName, dob, email, phoneNumber }, trainerId, delivery, requestId: startRequestId,
            })
            if (data.flowId) {
                navigate(getTrafficPostEoiPath(data, 'trafficImplementation'))
                return
            }
            setStudentName(`${firstName.trim()} ${lastName.trim()}`)
            setPriorNotice(data.creditedSections
                ? 'Your completed Traffic Control sections will be credited. Please complete a new EOI for this course. Both declarations are still required.'
                : 'Please complete EOI and the assessment sections for this course. Your trainer can help if an earlier completion was not found.')
            setPriorChecked(true)
        } catch (error) {
            setPriorNotice(error.response?.data?.error || 'The previous-assessment check is unavailable. Try again or continue with EOI; your eligibility will be checked when you submit it.')
        } finally {
            setLoading(false)
        }
    }

    if (!priorChecked) return <div className='form-wrapper studentTrafficEoi trafficEoiDisplay'>
        <h1>Start Traffic Implement Assessment</h1>
        <section className='studentDetailsModernGroup studentLlnDetailsCard'>
            <p>Enter the details used for your previous Traffic Control course, if any. We will check for completed sections so you do not have to repeat them.</p>
            <p>Verified EOI from yesterday can be reused. Earlier courses require a new EOI. Student and trainer declarations are required for every course.</p>
            <div className='studentLlnDetailsGrid'>
                <Input type='text' errors={errors} label='First Name' name='firstName' value={firstName} setValue={setFirstName} />
                <Input type='text' errors={errors} label='Last Name' name='lastName' value={lastName} setValue={setLastName} />
                <Input type='text' errors={errors} label='Date of Birth (DD/MM/YYYY)' name='dob' placeholder='DD/MM/YYYY' value={dob} setValue={handleDobChange} />
                <Input type='email' errors={errors} label='Email used for Traffic Control' name='email' value={email} setValue={setEmail} />
                <Input type='tel' errors={errors} label='Mobile number (if not using email)' name='phoneNumber' value={phoneNumber} setValue={setPhoneNumber} />
            </div>
            {priorNotice && <p role='status'>{priorNotice}</p>}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '24px' }}>
                <button type='button' className='studentLlnNextButton' disabled={loading || !trainerId || !delivery || !firstName.trim() || !lastName.trim() || !dob || (!email.trim() && !phoneNumber.trim())} onClick={checkPreviousTrafficCourse}>{loading ? 'Checking...' : 'Check and continue'}</button>
                <button type='button' className='studentLlnBackButton' disabled={loading} onClick={() => { setPriorChecked(true); setPriorNotice(''); }}>New student / continue with EOI</button>
            </div>
        </section>
    </div>

    if (pilotLoading || pilotError) return <div className='form-wrapper'><h1>Student enrolment</h1><p role={pilotError ? 'alert' : 'status'}>{pilotError || 'Loading your verified profile...'}</p><a href='/student-pilot'>Return to my courses</a></div>;
    return (<div className='form-wrapper studentTrafficEoi trafficEoiDisplay'>
        <h1>LLND & Evidence of Identity</h1>
        {priorNotice && <p role='status'>{priorNotice}</p>}

        {page === 0 ? <>
            <section className='studentDetailsModernGroup studentLlnDetailsCard'>
            <div className='studentLlnDetailsGrid'>
            <Input type={'text'} bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} errorMessage={errors.includes('studentName') && errors.length === 1 && errorMessage} errors={errors} name={'studentName'} value={studentName} setValue={setStudentName} label={'Student Full Name'} />
            <Input type={'text'} bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} disabled errorMessage={errors.includes('trainingCourse') && errors.length === 1 && errorMessage} errors={errors} name={'trainingCourse'} value={trainingCourse} setValue={setTrainingCourse} label={'Training Course'} />
            {/* <Input type={'text'} errorMessage={errors.includes('dateFirstPage') && errors.length === 1 && errorMessage} errors={errors} name={'dateFirstPage'} value={dateFirstPage} setValue={setDateFirstPage} label={'Date'} /> */}
            <div className='studentLlnDisabledDate'>
                <label style={{ display: 'flex', marginTop: '15px', fontWeight: '700', fontSize: '16px', color: '#64748b' }}>{'Date'}</label>
                <MyCalendar disabled startDate={dateFirstPage} setStartDate={setDateFirstPage} />
            </div>
            <Input disabled type={'text'} bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} errorMessage={errors.includes('trainerName') && errors.length === 1 && errorMessage} errors={errors} name={'trainerName'} value={trainerName} setValue={setTrainerName} label={'Trainer Name'} />
            <Input disabled type={'text'} bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} errorMessage={errors.includes('delivery') && errors.length === 1 && errorMessage} errors={errors} name={'delivery'} value={delivery} setValue={setDelivery} label={'Delivery'} />
            </div>
            </section>

            <section className='studentDetailsModernGroup studentLlnIntroCard'>
            <p>This pre training language, literacy, numeracy and digital assessment is carried out to assess your
                capabilities. As an RTO, we always try to deliver the highest standard of service, and to do this, we
                need to ensure you have the knowledge to complete this training course.</p>
            <p><b>Instructions:<br /></b>
                Complete the following exercises to the best of your ability. You should try to complete all tasks
                and take your time and read each question carefully.</p>
            <p><b>This evaluation is not a test<br /></b>
                The information you provide about your writing and math skills will help us plan support throughout
                the program. This information is confidential and will not be used for any other purpose and will
                remain the property of Upskill Institute.</p>
            </section>

            <section className='studentDetailsModernGroup studentLlnAssessmentCard'>
            <b className={errors.includes('iCan') && 'error'}>Tell us about your reading, writing and numeracy skills.</b>
            <table>
                <thead>
                    <tr>

                        <th>I can</th>
                        <th>Yes</th>
                        <th>Sometimes</th>
                        <th>No</th>
                    </tr>
                </thead>
                <tbody>
                    {iCanLabels.map((label, index) => <tr key={label}>
                        <td>{label}</td>
                        <td> <Radio checked={'Yes' === iCan[index]} label={'Yes'} setValue={v => setICan([...iCan.map((r, idx) => idx === index ? v : r)])} /></td>
                        <td> <Radio checked={'Sometimes' === iCan[index]} label={'Sometimes'} setValue={v => setICan([...iCan.map((r, idx) => idx === index ? v : r)])} /></td>
                        <td> <Radio checked={'No' === iCan[index]} label={'No'} setValue={v => setICan([...iCan.map((r, idx) => idx === index ? v : r)])} /></td>
                    </tr>)}
                </tbody>
            </table>
            <br />
            <b>1. Look at the group of words below. Arrange these words in alphabetical order</b>

            <p> sun - shop - stop - strong - some - spot</p>
            {/* {alphabetWords.map((word, index) =>
            <Input key={word + index} type={'text'} errors={[]} name={'alphabetWords'} value={word} setValue={v => setAlphabetWords(alphabetWords.map((r, idx) => idx === index ? v : r))} label={index + 1 + '.'} />
            )} */}

            <Input type={'text'} errors={errors} name={'alphabetWordOne'} value={alphabetWordOne} setValue={setAlphabetWordOne} label={1 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordTwo'} value={alphabetWordTwo} setValue={setAlphabetWordTwo} label={2 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordThree'} value={alphabetWordThree} setValue={setAlphabetWordThree} label={3 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordFour'} value={alphabetWordFour} setValue={setAlphabetWordFour} label={4 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordFive'} value={alphabetWordFive} setValue={setAlphabetWordFive} label={5 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordSix'} value={alphabetWordSix} setValue={setAlphabetWordSix} label={6 + '.'} />

            <br />
            <b className={errors.includes('chosenIncorrectWords') && 'error'}>2. Tick each incorrectly spelt words</b>
            <br />
            <br />
            <div className='checkboxGroup studentLlnSpellingGrid'>
                {incorrectWords.map(word =>
                    <Checkbox key={word} label={word} value={chosenIncorrectWords.includes(word)} setValue={(v) => toggleIncorrectWords(word, v)} />
                )}
            </div>

            <br />
            <br />
            <b>3. Write a short paragraph about why you are interested in doing this course?</b>
            <br />
            <textarea className={errors.includes('whyInterested') && 'error'} onChange={e => setWhyInterested(e.target.value)} value={whyInterested}></textarea>

            <b>4. Answer the following calculations.</b>
            <div className='studentLlnMathGrid'>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginTop: '40px' }}>a. 12 + 34 + 53 =</p>
                <Input type={'text'} errors={errors} name={'mathWordOne'} value={mathWordOne} setValue={setMathWordOne} label={''} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginTop: '40px' }}>b. 147 - 31 =</p>
                <Input type={'text'} errors={errors} name={'mathWordTwo'} value={mathWordTwo} setValue={setMathWordTwo} label={''} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginTop: '40px' }}>c. 11 x 8 =</p>
                <Input type={'text'} errors={errors} name={'mathWordThree'} value={mathWordThree} setValue={setMathWordThree} label={''} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginTop: '40px' }}>d. 100 ÷ 4 =</p>
                <Input type={'text'} errors={errors} name={'mathWordFour'} value={mathWordFour} setValue={setMathWordFour} label={''} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginTop: '40px' }}>e. $2.07 + $0.92 + $115.00 =</p>
                <Input type={'text'} errors={errors} name={'mathWordFive'} value={mathWordFive} setValue={setMathWordFive} label={''} />
            </div>
            </div>

            <br />
            <b>5. Why should you follow health and safety instructions?</b>
            <br />
            <textarea className={errors.includes('whyFollow') && 'error'} onChange={e => setWhyFollow(e.target.value)} value={whyFollow}></textarea>

            <br />
            <b>6. What types of traffic control equipment are you familiar with??</b>
            <br />
            <textarea className={errors.includes('familiarWith') && 'error'} onChange={e => setFamiliarWith(e.target.value)} value={familiarWith}></textarea>

            <br />
            <b>7. What are three vehicle type examples?</b>
            <br />
            <textarea className={errors.includes('vehicleExamples') && 'error'} onChange={e => setVehicleExamples(e.target.value)} value={vehicleExamples}></textarea>

            <br />
            <b>11. Oral Discussion</b>
            <p>Describe what you see in this picture below to your assessor. The Assessor will record your
                response below</p>
            <img src='https://upskillinstitute.com.au/wp-content/uploads/2021/03/Traffic-Oral.png' style={{ width: '100%' }} />
            <textarea className={errors.includes('oralDiscussion') && 'error'} onChange={e => setOralDiscussion(e.target.value)} value={oralDiscussion}></textarea>
            </section>


        </> :
            page === 1 ? <>

                <img src={Page1} style={{ width: '100%' }} />
            </> :
                page === 2 ? <>
                    <section className='studentDetailsModernGroup studentDetailsIdentityIntro'>
                    <h2 className='studentDetailsGroupHeading'>Evidence of Identity</h2>
                    <p>You must complete the evidence of identity check for this course. Please select one of the below.</p>
                    </section>

                    {<section className='studentDetailsModernGroup'>
                        <b className='studentDetailsGroupHeading studentDetailsIdentitySubheading'>Primary (only use one primary document)</b>

                        <Dropdown options={['Birth Certificate', 'Australian / International Passport', 'Australian Citizenship Certificate']} value={chosenPrimaryDocument} setValue={setChosenPrimaryDocument} label={'Choose Primary Document'} errorFields={errors} name={'primaryDocument'} />


                        {chosenPrimaryDocument && chosenPrimaryDocument.value === 'Birth Certificate' && <>
                            <Input labelStyle={{ fontSize: '16px', fontWeight: '400' }} type={'text'} errorMessage={errors.includes('birthCertificate') && errors.length === 1 && errorMessage} errors={errors} name={'birthCertificate'} value={birthCertificate} setValue={setBirthCertificate} label={'Australian Birth Certificate Number (70 points)'} />
                            <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={birthStateIssue} setValue={setBirthStateIssue} label={'State of Issue'} errorFields={errors} name={'birthStateIssue'} />
                        </>}


                        {chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian / International Passport' && <>
                            <Input bold type={'text'} errorMessage={errors.includes('passportNumber') && errors.length === 1 && errorMessage} errors={errors} name={'passportNumber'} value={passportNumber} setValue={setPassportNumber} label={'Passport Number (70 points)'} />
                            <Input bold type={'text'} errorMessage={errors.includes('passportCountry') && errors.length === 1 && errorMessage} errors={errors} name={'passportCountry'} value={passportCountry} setValue={setPassportCountry} label={'Country of Issue'} />
                        </>}

                        {chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian Citizenship Certificate' && <>
                            <Input bold type={'text'} errorMessage={errors.includes('citizenCert') && errors.length === 1 && errorMessage} errors={errors} name={'citizenCert'} value={citizenCert} setValue={setCitizenCert} label={'Australian Citizenship Certificate Number (70 points)'} />
                        </>}


                        <b className={`studentDetailsGroupHeading studentDetailsIdentitySubheading studentDetailsSecondaryHeading ${errors.includes('secondaryDoc') ? 'error' : ''}`}>Secondary</b>

                        <table className='flip-vertical-table'>

                            <tbody>
                                <tr>
                                    <td>Current Australian driver\'s licence or learner driver\'s licence (40 Points)</td>
                                    <td style={{ width: '160px' }}>
                                        <Input labelStyle={{ fontSize: '16px', fontWeight: '400' }} type={'text'} errorMessage={errors.includes('ausLicense') && errors.length === 1 && errorMessage} errors={errors} name={'ausLicense'} value={ausLicense} setValue={setAusLicense} label={'Number'} />
                                    </td>
                                    <td style={{ width: '120px' }}>
                                        <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={ausLicenseStateIssue} setValue={setAusLicenseStateIssue} label={'State of Issue'} errorFields={errors} name={'ausLicenseStateIssue'} />
                                    </td>
                                </tr>


                                <tr>
                                    <td>Current Australian Boat or PWC Licence (40 Points) </td>
                                    <td>
                                        <Input labelStyle={{ fontSize: '16px', fontWeight: '400' }} type={'text'} errorMessage={errors.includes('boatLicense') && errors.length === 1 && errorMessage} errors={errors} name={'boatLicense'} value={boatLicense} setValue={setBoatLicense} label={'Number'} />
                                    </td>
                                    <td>
                                        <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={boatLicenseStateIssue} setValue={setBoatLicenseStateIssue} label={'State of Issue'} errorFields={errors} name={'boatLicenseStateIssue'} />
                                    </td>
                                </tr>

                                <tr>
                                    <td>Current NSW Firearms Photo Licence (40 Points) </td>
                                    <td>
                                        <Input labelStyle={{ fontSize: '16px', fontWeight: '400' }} type={'text'} errorMessage={errors.includes('nswPhotoLicense') && errors.length === 1 && errorMessage} errors={errors} name={'nswPhotoLicense'} value={nswPhotoLicense} setValue={setNswPhotoLicense} label={'Number'} />
                                    </td>
                                    <td>
                                    </td>
                                </tr>


                                <tr>
                                    <td>Current Australian High Risk Work Licence (40 Points)</td>
                                    <td>
                                        <Input labelStyle={{ fontSize: '16px', fontWeight: '400' }} type={'text'} errorMessage={errors.includes('highRiskLicense') && errors.length === 1 && errorMessage} errors={errors} name={'highRiskLicense'} value={highRiskLicense} setValue={setHighRiskLicense} label={'Number'} />

                                    </td>
                                    <td>
                                        <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={highRiskLicenseState} setValue={setHighRiskLicenseState} label={'State of Issue'} errorFields={errors} name={'highRiskLicenseState'} />
                                    </td>
                                </tr>


                                <tr>
                                    <td>Current Australian Proof of Age or Photo Card - RMS Issued (40 Points)</td>
                                    <td>
                                        <Input labelStyle={{ fontSize: '16px', fontWeight: '400' }} type={'text'} errorMessage={errors.includes('proofAgeLicense') && errors.length === 1 && errorMessage} errors={errors} name={'proofAgeLicense'} value={proofAgeLicense} setValue={setProofAgeLicense} label={'Number'} />
                                    </td>
                                    <td>
                                        <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={proofAgeLicenseState} setValue={setProofAgeLicenseState} label={'State of Issue'} errorFields={errors} name={'proofAgeLicenseState'} />
                                    </td>
                                </tr>

                                <tr>
                                    <td>Australian Police or Dept of Defence card with photo (40 Points) </td>
                                    <td>
                                        <Input labelStyle={{ fontSize: '16px', fontWeight: '400' }} type={'text'} errorMessage={errors.includes('policeCard') && errors.length === 1 && errorMessage} errors={errors} name={'policeCard'} value={policeCard} setValue={setPoliceCard} label={'Number'} />

                                    </td>
                                    <td>
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                        <p style={{ fontWeight: '700', marginTop: '20px' }}>The following documents are worth 25 points.</p>

                        <Dropdown options={pointsDocumentOptions} isMulti value={pointsDocuments} setValue={setPointsDocuments} label={'You can select multiple documents'} errorFields={errors} name={'pointsDocuments'} />
                        <b className='studentDetailsIdentityNote'>Note: If using credit/savings cards or statements (up to a maximum of 2), these must be from different
                            financial institutions. 1 credit/savings card or statement equates to 25 points, 2 equals 50 points. </b>

                    </section>}


                </> :
                    page === 3 && <>

                        <section className='studentDetailsModernGroup'>
                        <label className='fieldHeading studentDetailsGroupHeading studentDetailsIdentitySubheading'>Write your full name as it appears on your ID</label>
                        <Dropdown options={['Mr', 'Mrs', 'Ms', 'Miss', 'Other']} value={title} setValue={setTitle} label={'Title'} errorFields={errors} name={'title'} />

                        <div className='flexrow'>
                            <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('firstName') && errors.length === 1 && errorMessage} errors={errors} name={'firstName'} value={firstName} setValue={setFirstName} label={'First Name'} />
                            <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('lastName') && errors.length === 1 && errorMessage} errors={errors} name={'lastName'} value={lastName} setValue={setLastName} label={'Last Name'} />
                        </div>
                        <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('otherName') && errors.length === 1 && errorMessage} errors={errors} name={'otherName'} value={otherName} setValue={setOtherName} label={'Other Name (Middle Name)'} />
                        </section>


                        <section className='studentDetailsModernGroup'>
                        <label className='fieldHeading studentDetailsGroupHeading'>Residential Address</label>

                        <AddressSearch errorMessage={errors.includes('address') && errors.length === 1 && errorMessage} errors={errors} value={address} setValue={setAddress} lockAddressManualFields={lockAddressManualFields} setLockAddressManualFields={setLockAddressManualFields} setAddressManualFill={setAddressManualFill} addressManualFill={addressManualFill} setStreetNumber={setStreetNumber} setStreetName={setStreetName} setSuburb={setSuburb} setState={setState} setPostcode={setPostcode} />
                        {addressManualFill && <>
                            <Input disabled={lockAddressManualFields} type={'text'} errorMessage={errors.includes('streetNumber') && errors.length === 1 && errorMessage} errors={errors} name={'streetNumber'} value={streetNumber} setValue={setStreetNumber} label={'Unit number/Street number/Property number'} />
                            <Input disabled={lockAddressManualFields} type={'text'} errorMessage={errors.includes('streetName') && errors.length === 1 && errorMessage} errors={errors} name={'streetName'} value={streetName} setValue={setStreetName} label={'Street Name'} />

                            <div className='flexrow'>
                                <Input disabled={lockAddressManualFields} type={'text'} errorMessage={errors.includes('suburb') && errors.length === 1 && errorMessage} errors={errors} name={'suburb'} value={suburb} setValue={setSuburb} label={'Suburb'} />
                                <div>
                                    <Dropdown disabled={lockAddressManualFields} options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={state} setValue={setState} label={'State'} errorFields={errors} name={'state'} />
                                </div>

                            </div>

                            <Input disabled={lockAddressManualFields} type={'text'} errorMessage={errors.includes('postcode') && errors.length === 1 && errorMessage} errors={errors} name={'postcode'} value={postcode} setValue={setPostcode} label={'Postcode'} />
                            {lockAddressManualFields && <label>Chose wrong address? <span style={{ textDecorationLine: 'underline' }} onClick={() => { setAddressManualFill(false); setLockAddressManualFields(false) }}>Enter again.</span></label>}

                        </>}



                        <div className='studentPostalAddressHeaderRow'>
                            <label className='fieldHeading studentDetailsGroupHeading studentPostalAddressHeading'>Postal Address</label>
                            <Checkbox disabled={!streetName || !suburb || !postcode} label={'Same as residential address'} value={postalAddressSame} setValue={setPostalAddressSame} />
                        </div>
                        {!postalAddressSame && <AddressSearch errorMessage={errors.includes('address') && errors.length === 1 && errorMessage} errors={errors} value={addressPostal} setValue={setAddressPostal} lockAddressManualFields={lockAddressPostalManualFields} setLockAddressManualFields={setLockAddressPostalManualFields} setAddressManualFill={setAddressPostalManualFill} addressManualFill={addressPostalManualFill} setStreetNumber={setStreetNumberPostal} setStreetName={setStreetNamePostal} setSuburb={setSuburbPostal} setState={setStatePostal} setPostcode={setPostcodePostal} />}

                        {(addressPostalManualFill || postalAddressSame) && <>
                            <Input disabled={lockAddressPostalManualFields} type={'text'} errorMessage={errors.includes('streetNumberPostal') && errors.length === 1 && errorMessage} errors={errors} name={'streetNumberPostal'} value={streetNumberPostal} setValue={setStreetNumberPostal} label={'Unit number/Street number/Property number'} />
                            <Input disabled={lockAddressPostalManualFields} type={'text'} errorMessage={errors.includes('streetNamePostal') && errors.length === 1 && errorMessage} errors={errors} name={'streetNamePostal'} value={streetNamePostal} setValue={setStreetNamePostal} label={'Street Name'} />

                            <div className='flexrow'>
                                <Input type={'text'} disabled={lockAddressPostalManualFields} errorMessage={errors.includes('suburbPostal') && errors.length === 1 && errorMessage} errors={errors} name={'suburbPostal'} value={suburbPostal} setValue={setSuburbPostal} label={'Suburb'} />
                                {/* <Input type={'text'} errorMessage={errors.includes('statePostal') && errors.length === 1 && errorMessage} errors={errors} name={'statePostal'} value={statePostal} setValue={setStatePostal} label={'State'} /> */}
                                <div>
                                    <Dropdown disabled={lockAddressPostalManualFields} options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={statePostal} setValue={setStatePostal} label={'State'} errorFields={errors} name={'statePostal'} />
                                </div>
                            </div>

                            <Input type={'text'} disabled={lockAddressPostalManualFields} errorMessage={errors.includes('postcodePostal') && errors.length === 1 && errorMessage} errors={errors} name={'postcodePostal'} value={postcodePostal} setValue={setPostcodePostal} label={'Postcode'} />
                            {lockAddressPostalManualFields && <label>Chose wrong address? <span style={{ textDecorationLine: 'underline' }} onClick={() => { setAddressPostalManualFill(false); setLockAddressPostalManualFields(false) }}>Enter again.</span></label>}

                        </>}
                        </section>


                        <section className='studentDetailsModernGroup'>
                        <div className='flexrow studentDetailsContactRow'>
                        <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('dob') && errors.length === 1 && errorMessage} errors={errors} placeholder={'DD/MM/YYYY'} name={'dob'} value={dob} setValue={handleDobChange} label={'Date of Birth (dd/mm/yyyy)'} />

                        <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'tel'} errorMessage={errors.includes('phoneNumber') && errors.length === 1 && errorMessage} errors={errors} name={'phoneNumber'} value={phoneNumber} setValue={setPhoneNumber} label={'Phone Number'} placeholder={'04XXXXXXXX'} />
                        </div>

                        <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('email') && errors.length === 1 && errorMessage} errors={errors} name={'email'} value={email} setValue={setEmail} label={'Email'} />
                        </section>

                        {/* <Input type={'text'} preventPaste errorMessage={errors.includes('emailConf') && errors.length === 1 && errorMessage} errors={errors} name={'emailConf'} value={emailConf} setValue={setEmailConf} label={'Repeat Email'} /> */}


                        <section className='studentDetailsModernGroup'>
                        <h3 className='studentDetailsGroupHeading studentDetailsIdentitySubheading'>Participant Declaration</h3>
                        <p> I declare that the details contained on this form are true and correct. The EOI details were provided to the RTO prior to attending TCWT or TCWT assessment under the WHS Regulation.</p>

                        <b>Participant's signature</b>
                        <br />
                        <br />
                        <SignatureCanvas penColor='black'
                            ref={signatureRef}
                            canvasProps={{ width: 500, height: 200, className: `sigCanvas ${errors.includes('signature') ? 'error' : ''}` }} />

                        <p>It is an offence under the Crimes Act 1900 (Crimes Act) and WHS Regulation to make false or misleading
                            statements in this application.</p>
                        <div>
                            <button style={{ color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={() => signatureRef.current.clear()}>Clear</button>
                        </div>
                        {/* <h3> Date of Declaration </h3> */}
                        <Input bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} placeholder={'DD-MM-YYYY'} errorMessage={errors.includes('declarationDate') && errors.length === 1 && errorMessage} errors={errors} name={'declarationDate'} value={declarationDate} disabled setValue={setDeclarationDate} label={'Date of Declaration'} />
                        </section>

                    </>
        }

        {errorMessage && errors.length > 0 && <p style={{ color: 'red', textAlign: 'center' }}>{errorMessage}</p>}

        <div style={{ display: 'flex', alignItems: 'center' }}>
            {page !== 0 && <button className='studentLlnBackButton' style={{ marginLeft: 'auto' }} disabled={page === 0 || loading} onClick={goToPrevPage}>Back</button>}
            <button className='studentLlnNextButton' style={{ marginLeft: page === 0 ? 'auto' : '20px' }} disabled={loading} onClick={handleNext}>{loading ? 'Loading...' : 'Next'}</button>
        </div>

        <StudentDetailConfirmationModal
            showModal={showDetailConfirmationModal}
            setShowModal={setShowDetailConfirmationModal}
            confirmationState={detailConfirmationState}
            setConfirmationState={setDetailConfirmationState}
            fieldValues={buildStudentDetailFieldValues({
                firstName,
                lastName,
                email,
                dob,
                streetNumber,
                streetName,
                suburb,
                state,
                postcode,
                streetNumberPostal,
                streetNamePostal,
                suburbPostal,
                statePostal,
                postcodePostal,
            })}
            onSubmit={handleDetailConfirmationSubmit}
            loading={loading}
        />

    </div >)
}

export default Traffic
